import React, { useRef, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login/Login';
import UserList from './UserList/UserList';
import Profile from './UserList/Profile';
import ChatPage from './ChatPage/ChatPage';
import Settings from './Settings/Settings';
import CallPage from './Call/CallPage';
import { SocketContext } from './context/SocketContext';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const socketRef = useRef(null); // ✅ shared socket

  useEffect(() => {
    const handleStorageChange = () => {
      setToken(localStorage.getItem('token'));
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <SocketContext.Provider value={socketRef}>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/users" element={token ? <UserList /> : <Navigate to="/" />} />
          <Route path="/profile/:mobile" element={token ? <Profile /> : <Navigate to="/" />} />
          <Route path="/chat/:recipientMobile" element={token ? <ChatPage /> : <Navigate to="/" />} />
          <Route path="/settings" element={token ? <Settings /> : <Navigate to="/" />} />
          <Route path="/call/:recipientMobile" element={<CallPage />} />
        </Routes>
      </Router>
    </SocketContext.Provider>
  );
}

export default App;
